import React from "react";

interface SkeletonLoaderProps {
  count: number;
  columns: number;
  className?: string;
}

const SKELETON_COL_WIDTHS: Record<number, string> = {
  0: 'w-10',      // 40px - ID column
  1: 'w-20',      // 80px - Status column
  2: 'w-[120px]', // Reference column
  3: 'w-[150px]', // Name column
  4: 'w-[200px]', // IBAN column
  5: 'w-[100px]', // BIC column
  6: 'w-[120px]', // Amount column
  7: 'w-[150px]', // Purpose column
  8: 'w-[200px]', // Error column
};

const SKELETON_COL_HEIGHTS: Record<number, string> = {
  1: 'h-6 rounded-xl', // Status column is taller with pill shape
};

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  count,
  columns,
  className = "bg-neutral-50 dark:bg-neutral-900 animate-pulse"
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <tr key={`skeleton-${index}`} className={className}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={`skeleton-cell-${colIndex}`} className="py-3 px-2 border-b border-neutral-200 dark:border-neutral-800">
              <div className={`bg-gradient-to-r from-neutral-100 via-neutral-200 to-neutral-100 dark:from-neutral-800 dark:via-neutral-700 dark:to-neutral-800 bg-[length:200%_100%] animate-pulse rounded ${SKELETON_COL_HEIGHTS[colIndex] || 'h-4'} ${SKELETON_COL_WIDTHS[colIndex] || 'w-full'}`}></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeletonLoader;
